import { Injectable } from '@angular/core';
import { gql, Query } from 'apollo-angular';

import { Query as RootQuery } from 'graphql/models/generated';

export const GET_SFTP_CREDENTIALS_QUERY = gql`
  query getSftpCredential($where: SftpCredentialWhereUniqueInput!) {
    getSftpCredential(where: $where) {
      id
      username
      port
      host
      valid
      remotePath
      branchId
    }
  }
`;

@Injectable({
  providedIn: 'root'
})

export class GetSftpCredentialQuery extends Query<RootQuery> {
  document = GET_SFTP_CREDENTIALS_QUERY;
}
